// ===========================
// ファイルアップロードのドロップゾーンデザイン適用
export default function initChangeUploadDropzone() {
    const $ = jQuery;

    const upload_dropzone_html = `
        <div class="c-form__upload-dropzone">
            <span class="c-form__upload-dropzone-icon" aria-hidden="true"></span>
            <p class="c-form__upload-dropzone-lead">
                <em>クリックして写真を選択</em> または ドラッグ&amp;ドロップ
            </p>
            <small class="c-form__upload-dropzone-note">JPG, PNG (各10MB、合計30MB以内)</small>
        </div>
        `;
    $('.quform-upload-dropzone-text').remove();
    $('.quform-element-1_19 .quform-upload-dropzone').prepend(upload_dropzone_html);
}